import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services';
import { ICompanyCOIChangeRequestDetails } from 'src/app/users/models/company.model';
import {environment} from '../../../environments/environment'
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }
  
 
  public getRecentRequirements(companyName:string,role:string): Observable<any> {
    return this.apiService.get(`Dashboard/GetRecentRequirement?companyName=${companyName}&role=${role}`);
  }

  public getDashboardCount(companyName:string,role:string):Observable<any>{
    return this.apiService.getInd(`Dashboard/GetDashboardCount?companyName=${companyName}&role=${role}`);
  }

  public adminDashboardCount():Observable<any>{
    return this.apiService.getInd(`Dashboard/adminDashboardCount`);
  }

  public getActivityTypeSummaryCount(companyName:string,role:string):Observable<any>{
    return this.apiService.get(`Dashboard/GetActivityTypeSummaryCount?companyName=${companyName}&role=${role}`);
  }

  public getReqByClientChartCount(companyName:string,role:string):Observable<any>{
    return this.apiService.get(`Dashboard/GetReqByClientChartCount?companyName=${companyName}&role=${role}`);
  }

  public getPlacementByClientChartCount(companyName:string,role:string):Observable<any>{
    return this.apiService.get(`Dashboard/GetPlacementByClientChartCount?companyName=${companyName}&role=${role}`);
  }
  
  public getRecentInterviews(companyName:string,role:string): Observable<any> {
    return this.apiService.get(`Dashboard/GetRecentInterview?companyName=${companyName}&role=${role}`);
  }
  public getPlacementStatus(companyName:string,role:string): Observable<any> {
    return this.apiService.get(`Dashboard/GetRecentPlacementStatus?companyName=${companyName}&role=${role}`);
  }


  public getVendorDashboardCount(vendorCompanyId:number): Observable<any> {
    return this.apiService.get(`Dashboard/vendordashboardcount/${vendorCompanyId}`);
  }
  public getAllDueCompanyDocumentChangeRequestList(dashboardDueSearchParam:IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`CompanyDocuments/GetAllDueCompanyDocuments`,dashboardDueSearchParam);
  }
  public getAllArchiveCompanyCOIChangeRequestList(dashboardArchiveSearchParam:IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`CompanyDocuments/GetAllArchiveCompanyDocumentRequest`,dashboardArchiveSearchParam);
  }
  public getCompanyDocumentById(documentId:number): Observable<any> {
    return this.apiService.get(`CompanyDocuments/GetCompanyDocumentById/${documentId}`);
  }
  public UpdateCompanyCOIChangeRequest(coidetails:ICompanyCOIChangeRequestDetails): Observable<any> {
    return this.apiService.post(`CompanyDocuments/ApporveCompanyDocument`,coidetails);
  }
  public RejectCompanyCOIChangeRequest(coidetails:ICompanyCOIChangeRequestDetails): Observable<any> {
    return this.apiService.post(`CompanyDocuments/RejectCompanyDocument`,coidetails);
  }
  public UpdateInvoiceStatus(companyId:number,userId:number): Observable<any> {
    return this.apiService.put(`Invoices/UpdatePaymentDueDateAfterCOIApproval/${companyId}/${userId}`);
  }
  public CheckVendorDocumentPendingNotification(vendorCompanyId:number):Observable<any>{
    return this.apiService.get(`Dashboard/CheckVendorDocumentPendingNotification/${vendorCompanyId}`)
  }
  public GetVendorOnboardProcessApprovalPendingAlerts(): Observable<any> {
    return this.apiService.get(`Dashboard/GetVendorOnboardProcessApprovalPendingAlerts`);
  }
}